import { gql } from '@apollo/client';

export const VIEWER_QUERY = gql`
    query getViewer {
        viewer {
            accountId
            id
            addresses(purpose: [MAIN, HOME, ALTERNATE]) {
                purpose
                address
                address2
                address3
                city
                stateProvince
                country
                purpose
                zip
                preferredMailing
                preferredBilling
            }
            birthdate
            blogUrl
            cellPhone
            company {
                id
                recordId
                name
                logoUrl
                description
                website
                phone
                linkedinUrl
                twitterUrl
                addresses(purpose: MAIN) {
                    purpose
                    address
                    address2
                    address3
                    city
                    stateProvince
                    country
                    purpose
                    zip
                    preferredBilling
                    preferredMailing
                }
                primaryBusinessType {
                    code
                    name
                }
                secondaryBusinessTypes {
                    code
                    name
                }
                minorityOwned
                womanOwned
            }
            description
            designations
            displayPhoto
            displayEmail
            deferredCompany {
                name
                recordId
            }
            email
            events {
                recordId
                code
            }
            fax
            firstCollege {
                code
                name
            }
            firstGraduationYear
            firstName
            functionalTitle
            gender
            hasSubscription
            hideAddressFields
            informal
            lastName
            linkedinUrl
            meetingInvites
            memberType
            middleName
            noCollege
            nonmemberCompany
            official
            paidThru
            personalResponsibility
            photoUrl
            prefix
            prospect
            recordId
            secondCollege {
                code
                name
            }
            secondGraduationYear
            secondaryEmail
            status
            studentMember
            suffix
            title
            twitterUrl
            workPhone
            messages
            notifications
            activeCommitteesFull {
                committee_id
                code
                name
                position
            }
            staff
        }
    }
`;

export const SAVED_ITEMS_QUERY = gql`
    query getSavedItems {
        articles {
            recordId
        }
        viewerEvents(type: SAVED) {
            recordId
        }
        contacts {
            recordId
        }
        publications {
            recordId
        }
        companies {
            recordId
        }
        sessions {
            recordId
        }
    }
`;

export const PROFILE_PHOTO_URLS_QUERY = gql`
    query getProfilePhotoUploadUrls {
        profilePhotoUploadUrls {
            full
            cropped
            tempFilename
        }
    }
`;

export const VIEWER_EVENTS_QUERY = gql`
    query getViewerEvents {
        viewer {
            events {
                recordId
                code
                title
                url
                beginsAt
                endsAt
            }
        }
    }
`;

export const UPDATE_PROFILE_PHOTO_MUTATION = gql`
    mutation UpdateProfilePhoto($memberId: Int!, $filename: String!) {
        updateProfilePhoto(memberId: $memberId, filename: $filename) {
            url
            file
        }
    }
`;